import React from "react";
import { To } from "@remix-run/router";
import "./buttons.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NavigationLink: React.FC<{ name: String; pathName: any; icon: any; icon2: any; disabled: boolean }> = ({
  name,
  pathName,
  icon,
  icon2,
  disabled,
}) => {
  return (
    <a href={pathName} target={disabled? "":"_blank"}>
      <div className={`nav-link-button ${disabled ? `nav-link-button-disabled`:``}`}>
        <div className="nav-link-button-icon">
          <FontAwesomeIcon icon={icon} />
        </div>
        <div className="coming-soon-css">
        <div>{name}</div>
        {
          disabled ?
          <div className="coming-soon-css-title">(Coming Soon)</div>
          :
          <></>
        }
        </div>
        <div className="nav-link-button-icon">
          <FontAwesomeIcon icon={icon2} />
        </div>
      </div>
    </a>
  );
};

export default NavigationLink;
